import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'
import type { FlowDefinition, FlowDefinitionInput, FlowScope } from '../models/flow'

export async function getFlows(
  scope?: FlowScope,
  clientType?: 'individual' | 'juridical'
): Promise<FlowDefinition[]> {
  const params = new URLSearchParams()
  if (scope) params.set('scope', scope)
  if (clientType) params.set('clientType', clientType)
  const qs = params.toString()
  const { data } = await axiosPrivate.get<FlowDefinition[]>(
    `${API.flows.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

export async function getFlow(id: string): Promise<FlowDefinition> {
  const { data } = await axiosPrivate.get<FlowDefinition>(API.flows.byId(id))
  return data
}

export async function createFlow(payload: FlowDefinitionInput): Promise<FlowDefinition> {
  const { data } = await axiosPrivate.post<FlowDefinition>(API.flows.root, payload)
  return data
}

export async function updateFlow(
  id: string,
  payload: Partial<FlowDefinitionInput>
): Promise<FlowDefinition> {
  const { data } = await axiosPrivate.patch<FlowDefinition>(API.flows.byId(id), payload)
  return data
}

export async function deactivateFlow(id: string): Promise<FlowDefinition> {
  const { data } = await axiosPrivate.delete<FlowDefinition>(API.flows.byId(id))
  return data
}
